import { NextPageContext } from 'next'
import styled from 'styled-components'
import { BackActionContainer } from '@/components/common/back-action/back-action-container'
import SearchProductHeader from '@/components/domains/layouts/header/SearchProductHeader'
import SeoHeader from '@/components/domains/layouts/header/SeoHeader'
import { SearchResultBody } from '@/components/domains/search/result/SearchResultBody'
import ROUTES, { RouteKeyName } from '@/constants/legacy/constRoutes'
import { QueryStringKeyEnum } from '@/constants/query-string-key.enum'
import { SearchResultContainer } from '@/containers/search/search-result.context'
import { AdPetType } from '@/graphql/generated/schemas'
import { getSeoKeywordByPetType } from '@/utils/utilSeo'
import { UtilUrlController } from '@/utils/utilUrlController'

const PageSearchResult = ({
  query: { [QueryStringKeyEnum.SearchPetType]: queryPetType, [QueryStringKeyEnum.SearchQuery]: searchKeyword },
}: NextPageContext) => {
  const canonical = ROUTES.SEARCH_KEYWORD.replace(
    RouteKeyName.PetType,
    UtilUrlController.urlParamToPetType(queryPetType)
  ).replace(RouteKeyName.Keyword, searchKeyword as string)
  const { petType, petOwner } = getSeoKeywordByPetType(queryPetType as AdPetType)

  return (
    <>
      <SeoHeader
        title={`${searchKeyword} | 검색 결과 - 핏펫몰`}
        metaDescription={`핏펫이 직접 고르고 엄선한 ${petType}를 위한 ${searchKeyword} 제품들을 한자리에 모았습니다.\n${petType}와 ${petOwner}들이 모두 좋아하는 완벽한 ${petType} 전용 ${searchKeyword} 제품들을 지금 바로 핏펫에서 만나보세요`}
        pathname={canonical}
      />
      <SearchResultContainer.Provider>
        <SearchProductHeader />
        <BackActionContainer name="recommend-list-for-search-result">
          <SearchResultBody />
        </BackActionContainer>
      </SearchResultContainer.Provider>
    </>
  )
}

export default PageSearchResult

export const ABFlag = styled.div`
  position: fixed;
  background-color: white;
  left: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 2px solid black;
  font-weight: bold;
  font-size: 1rem;
`

export const getServerSideProps = async ({ query }: NextPageContext) => {
  return {
    props: {
      query,
    },
  }
}
